export const brand = {
  name: 'Biblioteca de Sabiduría de Salomón',
  short: 'BIBLIOTECA DE SABIDURÍA DE SALOMÓN',
  tag: 'Basado en Proverbios y Eclesiastés',
}

export const checkoutUrl = '#inversion'

export const mockups = {
  kit: 'https://cdn.magicpatterns.com/uploads/mT4xQBGjZFSax32iHgRtqA/mockup1.png',
}

export const heroFacts: string[] = [
  'Acceso inmediato',
  '130+ mapas',
  '4 tomos',
  '6 bonos',
]

export interface SampleMap {
  src: string
  alt: string
}

export const sampleMaps: SampleMap[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/bxcfYdrW9sBBMXycvfiai4/Captura_de_pantalla_2026-09-21_a_la(s)_4.39.06_p._m..png',
    alt: 'Mapa visual “Nunca tomes una gran decisión en soledad”, con versículo de Proverbios 11:14, puntos clave, acción sabia y trampa',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8cHtU8S8FPQHpdGMymd1CN/Captura_de_pantalla_2026-09-21_a_la(s)_4.39.50_p._m..png',
    alt: 'Mapa visual “Hay consejeros sabios y consejeros equivocados”, con ilustración comparativa y Proverbios 13:20',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/35J7ce5nZiTpJZ5pfqz6i1/Captura_de_pantalla_2026-09-21_a_la(s)_4.41.04_p._m..png',
    alt: 'Mapa 15: “El trabajo honesto es mejor que la ganancia rápida”, con Proverbios 10:2 y aplicación práctica',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tNtHNGh9G1XmK6mzYe2qG3/Captura_de_pantalla_2026-09-21_a_la(s)_4.41.35_p._m..png',
    alt: 'Mapa visual “Eres más productivo descansado que agotado”, con reflexión, acción sabia y verdad incómoda',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/j9DD8ttcSzs74GLgWYq3XC/Captura_de_pantalla_2026-09-21_a_la(s)_4.41.56_p._m..png',
    alt: 'Mapa visual sobre la ansiedad y los tiempos de la vida, con una rueda de tiempos y afirmaciones para aplicar',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tpudKipxvxCC2z2uaW4DPG/Captura_de_pantalla_2026-09-21_a_la(s)_4.42.28_p._m..png',
    alt: 'Mapa visual “En el silencio encuentro lo que pierdo en el ruido”, con acción sabia de 15 minutos de silencio',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kb8iNL1gg9MQ91zHRYFkTZ/Captura_de_pantalla_2026-09-21_a_la(s)_4.44.15_p._m..png',
    alt: 'Mapa 17: “La multitarea en finanzas te destruye”, con Mateo 6:24 y dos aplicaciones concretas',
  },
]

export interface Bonus {
  tag: string
  title: string
  lead: string
  value: string
  /** Subí acá el mockup del bono. Dejalo vacío para mostrar el espacio reservado. */
  image: string
}

/** Valor total de los 6 bonos sumados, que hoy se regala. */
export const bonusesTotalValue = '$29.940'

export const bonuses: Bonus[] = [
  {
    tag: 'Bono 1',
    title: 'Índice SOS de Sabiduría Inmediata',
    lead: 'Encontrá qué consultar según lo que estés viviendo.',
    value: '$4.990',
    image: 'https://cdn.magicpatterns.com/uploads/7bdDdtE4FrwcC1nbzZU4ph/mockup-bono1.png',
  },
  {
    tag: 'Bono 2',
    title: 'Plan de 7 Días para Activar la Biblioteca',
    lead: 'Ruta simple para empezar sin sentirte abrumado.',
    value: '$4.990',
    image: 'https://cdn.magicpatterns.com/uploads/pbi3U6kNiReZRhC7zAFkgS/mockup-bono2.png',
  },
  {
    tag: 'Bono 3',
    title: 'Plantillas de Oración y Reflexión para Decidir con Paz',
    lead: 'Oraciones guiadas para momentos de presión, conflicto e incertidumbre.',
    value: '$4.990',
    image: 'https://cdn.magicpatterns.com/uploads/3egrF3HELSfN8k8vjNd1Bf/mockupbono3.png',
  },
  {
    tag: 'Bono 4',
    title: 'Kit Imprimible de Uso Familiar',
    lead: 'Hojas y dinámicas para usar en casa con tu pareja o tus hijos.',
    value: '$4.990',
    image: 'https://cdn.magicpatterns.com/uploads/udP3E8LsuzkCQtRqvdM3GR/mockupbono4.png',
  },
  {
    tag: 'Bono 5',
    title: 'Scripts de Conversaciones Difíciles con Sabiduría',
    lead: 'Frases listas para pedir perdón, poner límites y desactivar discusiones.',
    value: '$4.990',
    image: 'https://cdn.magicpatterns.com/uploads/2oZHopukmVVSDdaoVkEQqD/mockupbono5.png',
  },
  {
    tag: 'Bono 6',
    title: 'Tracker de Decisiones Sabias',
    lead: 'Plantilla para evaluar decisiones importantes antes de actuar por impulso.',
    value: '$4.990',
    image: 'https://cdn.magicpatterns.com/uploads/u8knpbYZJEvL3hA6ztmrgy/mockupobono6.png',
  },
]

export const offer = {
  listPrice: '$24.990',
  price: '$14.990',
  currency: 'ARS',
  subtitle: 'Pago único | Acceso de por vida',
  detail:
    'Un único pago. Sin mensualidades. De por vida. Acceso inmediato: en 5 minutos recibís todo por email.',
  cta: 'Acceder a la Biblioteca ahora',
  badge: 'Biblioteca completa',
  totalValue: '$54.930',
  lines: [
    { label: 'Biblioteca de Sabiduría de Salomón (4 tomos, 130+ mapas en PDF)', value: '$24.990' },
    { label: '6 bonos exclusivos incluidos', value: '$29.940' },
  ],
  microcopy: 'Pago único, acceso de por vida. Sin suscripción.',
  reassurance: 'Acceso inmediato · Pago único · Uso de por vida · Garantía de 7 días',
}

export const trustItems = [
  { icon: 'lock', label: 'Pago 100% seguro' },
  { icon: 'check', label: 'Acceso inmediato' },
  { icon: 'money', label: 'Garantía 7 días' },
  { icon: 'mail', label: 'Soporte por email' },
] as const

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Cuándo recibo el material?',
    answer: 'Inmediatamente después de pagar. En 5 minutos tenés todo en tu email.',
  },
  {
    question: '¿Vienen listos para imprimir?',
    answer: 'Sí. Alta resolución (300 DPI). Perfectos para imprimir en A4.',
  },
  {
    question: '¿Necesito ser cristiano?',
    answer: 'No. Los principios funcionan independientemente de tu fe.',
  },
  {
    question: '¿Puedo usarlo con mi familia o grupo?',
    answer: 'Sí. Uso ilimitado de por vida.',
  },
  {
    question: '¿Qué pasa si cambio de dispositivo?',
    answer:
      'Acceso de por vida. Descargás desde cualquier dispositivo, cuando quieras.',
  },
  {
    question: '¿Esto sustituye terapia o consejo profesional?',
    answer:
      'No. Es una herramienta de reflexión. Si necesitás ayuda profesional, buscala.',
  },
]
